import { NavLink } from "react-router-dom";
import { Home, CalendarDays, HandHeart, HandHelping, AtSign } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { motion } from "framer-motion";

const tabConfig = [
  { to: "/", key: "home", icon: Home, testid: "bottom-tab-home", end: true },
  { to: "/events", key: "events", icon: CalendarDays, testid: "bottom-tab-events" },
  { to: "/give", key: "give", icon: HandHeart, testid: "bottom-tab-give", emphasis: true },
  { to: "/prayers", key: "prayer", icon: HandHelping, testid: "bottom-tab-prayer" },
  { to: "/social", key: "social", icon: AtSign, testid: "bottom-tab-social" },
];

export function BottomTabBar() {
  const { t } = useI18n();
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-[100] border-t border-border bg-background shadow-[0_-8px_24px_rgba(0,0,0,0.06)] pb-safe"
      style={{
        // Force the tab bar onto its own GPU compositing layer so iOS Safari
        // never hides it during momentum scrolling and so it stays anchored
        // even when the browser URL bar collapses/expands.
        transform: "translate3d(0, 0, 0)",
        WebkitTransform: "translate3d(0, 0, 0)",
        willChange: "transform",
        WebkitBackfaceVisibility: "hidden",
      }}
      data-testid="bottom-tab-bar"
    >
      <div className="mx-auto flex max-w-md items-stretch">
        {tabConfig.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.key}
              to={tab.to}
              end={tab.end}
              data-testid={tab.testid}
              className={({ isActive }) =>
                `relative flex flex-1 flex-col items-center justify-center gap-1 py-2 min-h-[64px] transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`flex h-9 w-9 items-center justify-center rounded-full ${
                      tab.emphasis
                        ? "bg-primary text-primary-foreground shadow ring-2 ring-primary/20"
                        : isActive
                        ? "bg-primary/10"
                        : ""
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="text-[11px] font-medium">{t.nav[tab.key]}</span>
                  {isActive && !tab.emphasis && (
                    <motion.span
                      layoutId="active-tab"
                      className="absolute bottom-1 h-[3px] w-6 rounded-full bg-primary"
                      transition={{ type: "spring", stiffness: 380, damping: 30 }}
                    />
                  )}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
